import React from 'react'
import { Box } from '@mui/material'
import patternRight from '../../../../../common/images/gridPatternRight.png'
import patternLeft from '../../../../../common/images/gridPatternLeft.png'
import {
  campaignPreviewWrapperStyles,
  gradientBackgroundStyles,
  patternImageStyles,
  contentWrapperStyles
} from './launchCampaignStyles'

export default function CampaignPreviewWrapper({ children }) {
  return (
    <Box sx={campaignPreviewWrapperStyles}>
      <Box sx={gradientBackgroundStyles}>
        <Box component='img' alt='pattern-right' src={patternRight} sx={patternImageStyles('right')} />
        <Box component='img' alt='pattern-left' src={patternLeft} sx={patternImageStyles('left')} />
      </Box>
      <Box sx={contentWrapperStyles}>{children}</Box>
    </Box>
  )
}
